module.exports = __webpack_public_path__ + "fe87c3478f432e264468d5991e780a0f.png";